module.exports = __webpack_public_path__ + "img/location.bebaf970.svg";